import { render, staticRenderFns } from "./loan-project-invoices-card.vue?vue&type=template&id=712dd7de&scoped=true&"
import script from "./loan-project-invoices-card.vue?vue&type=script&lang=js&"
export * from "./loan-project-invoices-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712dd7de",
  null
  
)

export default component.exports